import { render, staticRenderFns } from "./QueryLionI.vue?vue&type=template&id=1f472803&"
import script from "./QueryLionI.vue?vue&type=script&lang=js&"
export * from "./QueryLionI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports